import React from 'react';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import LoginScreen from "./screens/mainscreen/LoginScreen";
import RegisterScreen from "./screens/mainscreen/RegisterScreen";
import {ProjectsScreen} from "./screens/mainscreen/ProjectsScreen";
import EquipmentScreen from "./screens/mainscreen/EquipmentScreen";
import EquipmentAnalyticsScreen from "./screens/mainscreen/EquipmentAnalyticsScreen";
import ProjectEditScreen from "./screens/admin/ProjectEditScreen";
import SettingsScreen from "./screens/admin/SettingsScreen";
import MyProjectScreen from "./screens/admin/MyProjectScreen";
import MyEquipmentScreen from "./screens/admin/MyEquipmentScreen";
import ContactUsScreen from "./screens/mainscreen/ContactUsScreen";
import AboutUsScreen from "./screens/mainscreen/AboutUsScreen";
import ProjectAnalyticsScreen from "./screens/mainscreen/ProjectAnalyticsScreen";
import EquipmentEditScreen from "./screens/admin/EquipmentEditScreen";
import VerifyEmailScreen from "./screens/admin/VerifyEmailScreen";
import ForgotPasswordPage from "./screens/admin/ForgotPasswordPage";
import {ChatMainScreen} from "./screens/AIChatScreen/Rev1Chat/ChatPage/ChatMainScreen";
import DocumentIngestionPage from "../src/screens/AIChatScreen/DocumentIngestionPage"
import SignalRProvider from "../src/SignalRProvider/SignalRProvider";
import PasswordResetScreen from "../src/screens/admin/PasswordResetScreen";
import ExcelngestionPage from "../src/screens/AIChatScreen/ExcelngestionPage";
import {ExcelCard} from "../src/components/ExcelCard";
import {ConversationMainScreen} from "./screens/AIChatScreen/Rev1Chat/ChatPage/ConversationMainScreen";
import {ChatSpreadSheet} from "../src/screens/AIChatScreen/ChatSpreadSheet";
import DocumentPreviewScreen from "../src/screens/AIChatScreen/DocumentPreviewScreen";
import {PlayWrightQueryDashboard} from "./screens/AIChatScreen/Rev1Chat/PlayWrightChatPage/PlayWrightQueryDashboard";
import PlaybookProject from "./screens/AIChatScreen/Rev1Chat/PlayWrightChatPage/PlaybookProject";
import PlaybookTableScreen from "./screens/AIChatScreen/Rev1Chat/PlayWrightChatPage/PlaybookTableScreen";
import AssistantChatScreen from "./screens/AIChatScreen/Rev1Chat/AssistantChatScreen";
import SinglePlayQueryScreen from "./screens/AIChatScreen/Rev1Chat/SinglePlayQueryScreen";
import PlayWrightQueryChat from "./screens/AIChatScreen/Rev1Chat/PlayWrightChatPage/PlayWrightQueryChat";
import QueryChatScreen from "../src/screens/AIChatScreen/Rev1Chat/QueryChatScreen"
import NewHomeScreenPage from "../src/screens/mainscreen/NewHomeScreenPage";
import ExcelProjectQueryDashboard
    from "./screens/AIChatScreen/Rev1Chat/ChatPage/ExcelProjectQueryDashboard";

import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc =
    window.location.origin + "/pdf.worker.min.js";

function App() {
  return (
    <>
        <Router>
            <ToastContainer />

            <Routes>
                <Route path="/" element={<NewHomeScreenPage/>} />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/register" element={<RegisterScreen />} />
                <Route path={"/projects"} element={<ProjectsScreen />} />
                <Route path={"/projects/:id"} element={<ProjectEditScreen />} />
                <Route path={"/equipments/:id"} element={<EquipmentEditScreen />} />
                <Route path={"/equipments"} element={<EquipmentScreen />} />
                <Route path={"/equipmentAnalytics"} element={<EquipmentAnalyticsScreen />} />
                <Route path={"/projects/user/:id"} element={<MyProjectScreen />} />
                <Route path={"/equipments/user/:id"} element={<MyEquipmentScreen />} />
                <Route path={"/contactUs"} element={<ContactUsScreen />} />
                <Route path={"/about"} element={<AboutUsScreen />} />
                <Route path={"/settings"} element={<SettingsScreen />} />
                <Route path={"/verifyEmail"} element={<VerifyEmailScreen />} />
                <Route path={"/forgotPassword"} element={<ForgotPasswordPage />} />
                <Route path={"/projectAnalytics"} element={<ProjectAnalyticsScreen />} />
                <Route path={"/chat"} element={<ChatMainScreen />} />
                <Route path={"/documentingestion"} element={<DocumentIngestionPage/>}/>
                <Route path={"/excelingestion"} element={<ExcelngestionPage/>}/>
                <Route path={"/signalr"} element={<SignalRProvider />} />
                <Route path={"/resetPassword"} element={<PasswordResetScreen />} />
                <Route path={"excellists"} element={<ExcelCard />} />
                <Route path={"/chat/:id"} element={<ConversationMainScreen/>} />
                <Route path={"/spreadsheet"} element={<ChatSpreadSheet/>} />
                <Route path={"/documentViewer"} element={<DocumentPreviewScreen />} />
                <Route path={"playbookProject/playWrightQuery/:id"} element={<PlayWrightQueryDashboard />} />
                <Route path={"playbookProject"} element={<PlaybookProject />} />
                <Route path={"tabular-review/:id"} element={<PlaybookTableScreen />} />
                <Route path={"/assistantScreen"} element={<AssistantChatScreen />} />
                <Route path={"single-query-review/:id"} element={<SinglePlayQueryScreen />} />
                <Route path={"playbookQuery/chat/:id"} element={<PlayWrightQueryChat />} />
                <Route path={`playWrightQuery/chatItem/:id`} element={<QueryChatScreen />} />
                <Route path={"excelProjectQuery/excelchatItem/:id"} element={<ExcelProjectQueryDashboard/>} />

            </Routes>

        </Router>



    </>
  );
}

export default App;
